import { Snackbar } from '@material-ui/core';
import MuiAlert, { AlertProps, Color } from '@material-ui/lab/Alert';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { ReactNode } from 'react';

const useAlertStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: theme.spacing(3),
      paddingRight: theme.spacing(2.5)
    }
  })
);

function Alert(props: AlertProps) {
  const classes = useAlertStyles();
  return <MuiAlert className={classes.root} elevation={6} {...props} />;
}

interface AlertBoxProps {
  open: boolean;
  onClose: () => void;
  autoHideDuration: number;
  severity: Color;
  children: ReactNode;
}

export default function AlertBox({
  open,
  onClose,
  autoHideDuration,
  severity,
  children
}: AlertBoxProps) {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
    >
      <Alert onClose={onClose} severity={severity}>
        {children}
      </Alert>
    </Snackbar>
  );
}
